import React from 'react';
import PropTypes from 'prop-types';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import { RadioButtonGroup, RadioButton } from 'material-ui/RadioButton';
import { EXAM_TYPE } from '../utils/constants';

export default function ExamTypeSelector({ input, t, ...rest }) {
  return (
    <MuiThemeProvider>
      <RadioButtonGroup
        {...input}
        {...rest}
        valueSelected={input.value}
        onChange={(event, value) => input.onChange(value)}
        className="radio-button-selector"
      >
        <RadioButton
          iconStyle={{ fill: '#646777' }}
          labelStyle={{ color: '#646777' }}
          value={EXAM_TYPE.NEW}
          label={t(`communication.exam-type.${EXAM_TYPE.NEW}`)}
        />
        <RadioButton
          iconStyle={{ fill: '#646777' }}
          labelStyle={{ color: '#646777' }}
          value={EXAM_TYPE.RECOVERY}
          label={t(`communication.exam-type.${EXAM_TYPE.RECOVERY}`)}
        />
        <RadioButton
          iconStyle={{ fill: '#646777' }}
          labelStyle={{ color: '#646777' }}
          value={EXAM_TYPE.SUBSTITUTE}
          label={t(`communication.exam-type.${EXAM_TYPE.SUBSTITUTE}`)}
        />
      </RadioButtonGroup>
    </MuiThemeProvider>
  );
}

ExamTypeSelector.propTypes = {
  input: PropTypes.shape().isRequired,
  t: PropTypes.func.isRequired,
};
